/* ============================================================
   MATERIE PRIME TRASPARENTI — modal + show all
   Performance-first:
   - Popup HTML pre-renderizzato server-side dentro <template>
   - JS al click fa solo template.cloneNode() → render istantaneo (~1ms)
   - Modal aperto/chiuso via class toggle, transition GPU (transform+opacity)
   - Image preload predittivo on hover
   ============================================================ */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function openModal(section, card) {
    var modal = $('[data-mpt-modal]', section);
    var contentSlot = $('[data-mpt-modal-content]', section);
    if (!modal || !contentSlot) return;

    var ingId = card.getAttribute('data-ing-id');
    if (!ingId) return;

    var tpl = document.getElementById('mpt-tpl-' + ingId);
    if (!tpl || !tpl.content) return;

    // Swap content (template clone is the fastest DOM op)
    contentSlot.replaceChildren(tpl.content.cloneNode(true));

    // Open modal — class toggle triggers CSS transition
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mpt-no-scroll');

    // Focus management (next frame so transition has started)
    requestAnimationFrame(function () {
      var closeBtn = $('.mpt-modal__close', modal);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  function closeModal(section) {
    var modal = $('[data-mpt-modal]', section);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mpt-no-scroll');
  }

  function showAll(section) {
    $$('.mpt-card.is-hidden', section).forEach(function (c) { c.classList.remove('is-hidden'); });
    var btn = $('[data-mpt-show-all]', section);
    if (btn) btn.style.display = 'none';
  }

  // Predictive image preload on card hover (warm browser cache for modal image)
  function preloadModalImage(card) {
    var ingId = card.getAttribute('data-ing-id');
    if (!ingId) return;
    var tpl = document.getElementById('mpt-tpl-' + ingId);
    if (!tpl || !tpl.content) return;
    var img = tpl.content.querySelector('img.mpt-modal__img');
    if (!img || img.dataset.preloaded) return;
    var src = img.getAttribute('src');
    if (!src) return;
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = src;
    img.dataset.preloaded = '1';
  }

  /* ── Filter bar (gruppi olfattivi + ricerca + ALTRE overflow) ── */
  function attachFilter(section) {
    var tabsContainer = $('[data-mpt-filter-bar] .mpt-filter-bar__tabs', section);
    var tabs          = $$('[data-mpt-filter-bar] .mpt-filter__tab', section);
    var searchInput   = $('[data-mpt-search]', section);
    var grid          = $('[data-mpt-grid]', section);
    var showAllWrap   = $('.mpt-section__cta-wrap', section);
    if (!tabs.length && !searchInput) return;

    var activeFilter = 'all';
    var searchVal    = '';
    var showAllUsed  = false;
    var altreBtn     = null;

    /* ── applyFilter ─────────────────────────────────────────── */
    function applyFilter() {
      var cards       = $$('[data-mpt-card]', section);
      var isFiltering = activeFilter !== 'all' || searchVal !== '';
      var anyVisible  = false;
      var showCount   = parseInt(grid ? (grid.getAttribute('data-show') || '8') : '8', 10);

      if (showAllWrap) showAllWrap.style.display = isFiltering ? 'none' : '';

      cards.forEach(function (card, idx) {
        var grp   = (card.getAttribute('data-gruppo') || '').toLowerCase().trim();
        var title = (card.getAttribute('data-title')  || '').toLowerCase();
        var ok    = (activeFilter === 'all' || grp === activeFilter) &&
                    (searchVal === '' || title.indexOf(searchVal) !== -1);
        card.classList.toggle('mpt-card--filtered', !ok);
        if (ok) {
          if (isFiltering) card.classList.remove('is-hidden');
          anyVisible = true;
        }
      });

      if (!isFiltering && !showAllUsed) {
        cards.forEach(function (card, idx) {
          if (idx >= showCount) card.classList.add('is-hidden');
        });
      }

      var emptyMsg = $('.mpt-filter-empty', section);
      if (emptyMsg) emptyMsg.classList.toggle('is-visible', !anyVisible);
    }

    /* ── Tab click ───────────────────────────────────────────── */
    function onTabClick(tab) {
      activeFilter = tab.getAttribute('data-filter') || 'all';
      tabs.forEach(function (t) {
        t.classList.remove('mpt-filter__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('mpt-filter__tab--active');
      tab.setAttribute('aria-selected', 'true');

      /* Evidenzia ALTRE se il tab attivo è nel dropdown */
      if (altreBtn) {
        var inDropdown = !!tab.closest('.mpt-filter__dropdown');
        altreBtn.classList.toggle('mpt-filter__tab--active-child', inDropdown);
      }
      applyFilter();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { onTabClick(tab); });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchVal = (searchInput.value || '').toLowerCase().trim();
        applyFilter();
      });
    }

    /* ── Scroll orizzontale continuo (frecce prev/next) ──────── */
    var bar = $('[data-mpt-filter-bar]', section);
    if (tabsContainer && bar) {
      tabsContainer.classList.add('mpt-filter-bar__tabs--scroll');

      var SVG_NS = 'http://www.w3.org/2000/svg';
      function makeArrow(dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mpt-filter__scroll-arrow mpt-filter__scroll-arrow--' + dir;
        btn.setAttribute('aria-label', dir === 'next' ? 'Scorri avanti' : 'Scorri indietro');
        btn.innerHTML = dir === 'next'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
        return btn;
      }

      var prevArrow = makeArrow('prev');
      var nextArrow = makeArrow('next');

      /* Inserisci prevArrow prima dei tabs, nextArrow subito dopo */
      bar.insertBefore(prevArrow, tabsContainer);
      if (tabsContainer.nextSibling) {
        bar.insertBefore(nextArrow, tabsContainer.nextSibling);
      } else {
        bar.appendChild(nextArrow);
      }

      function updateArrows() {
        var sl  = tabsContainer.scrollLeft;
        var max = tabsContainer.scrollWidth - tabsContainer.clientWidth;
        var scrollable = max > 4;
        var atStart = sl <= 2;
        var atEnd   = sl >= max - 2;

        prevArrow.classList.toggle('is-hidden', !scrollable || atStart);
        nextArrow.classList.toggle('is-hidden', !scrollable || atEnd);

        /* Sfumatura ai bordi (fade) in base alla posizione di scroll */
        tabsContainer.classList.remove('fade-start', 'fade-end', 'fade-both');
        if (scrollable) {
          if (!atStart && !atEnd)      tabsContainer.classList.add('fade-both');
          else if (atStart && !atEnd)  tabsContainer.classList.add('fade-end');
          else if (!atStart && atEnd)  tabsContainer.classList.add('fade-start');
        }
      }

      function scrollByStep(delta) {
        tabsContainer.scrollBy({ left: delta, behavior: 'smooth' });
      }

      nextArrow.addEventListener('click', function () { scrollByStep(Math.max(220, tabsContainer.clientWidth * 0.6)); });
      prevArrow.addEventListener('click', function () { scrollByStep(-Math.max(220, tabsContainer.clientWidth * 0.6)); });
      tabsContainer.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);

      /* ── Wheel verticale → scroll orizzontale ──────────────── */
      tabsContainer.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          tabsContainer.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });

      /* ── Drag-to-scroll col mouse (desktop) ────────────────── */
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      tabsContainer.addEventListener('mousedown', function (e) {
        isDown = true; moved = false;
        startX = e.pageX;
        startScroll = tabsContainer.scrollLeft;
        tabsContainer.classList.add('is-dragging');
      });
      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 4) moved = true;
        tabsContainer.scrollLeft = startScroll - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        tabsContainer.classList.remove('is-dragging');
      });
      /* Blocca il click sul tab se è stato un drag (non un click pulito) */
      tabsContainer.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      /* Touch su mobile: nativo via overflow-x; assicura momentum iOS */
      tabsContainer.style.webkitOverflowScrolling = 'touch';

      /* Scroll automatico per portare in vista il tab attivo cliccato */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (moved) return;
          try { tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
        });
      });

      /* init (dopo layout) */
      setTimeout(updateArrows, 60);
      updateArrows();
    }

    /* ── Show-all tracking ───────────────────────────────────── */
    var showAllBtn = $('[data-mpt-show-all]', section);
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () { showAllUsed = true; });
    }

    /* ── No-results slot ─────────────────────────────────────── */
    if (grid && !$('.mpt-filter-empty', grid)) {
      var emp = document.createElement('p');
      emp.className = 'mpt-filter-empty';
      emp.setAttribute('aria-live', 'polite');
      emp.textContent = 'Nessuna materia prima trovata per questa selezione.';
      grid.appendChild(emp);
    }
  }

  function attach(section) {
    if (section.dataset.mptInit) return;
    section.dataset.mptInit = '1';

    attachFilter(section);

    var cards = $$('[data-mpt-card]', section);

    cards.forEach(function (card) {
      // open
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        openModal(section, card);
      });

      // keyboard a11y
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(section, card);
        }
      });

      // predictive preload (hover/focus)
      card.addEventListener('mouseenter', function () { preloadModalImage(card); }, { passive: true });
      card.addEventListener('focus', function () { preloadModalImage(card); }, true);
    });

    // Close
    $$('[data-mpt-close]', section).forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(section); });
    });

    // Show all
    var showAllBtn = $('[data-mpt-show-all]', section);
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () { showAll(section); });
    }
  }

  function init() {
    $$('.mpt-section').forEach(attach);
  }

  // ESC key — global, set once
  if (!window.__mptEscBound) {
    window.__mptEscBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        $$('.mpt-modal.is-open').forEach(function (m) {
          m.classList.remove('is-open');
          m.setAttribute('aria-hidden', 'true');
        });
        document.body.classList.remove('mpt-no-scroll');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
